import api from "../../api";
import { TipoBanca, TipoBancaNome } from "../../model/banca/Banca";
import { Vinculo } from "../../model/Pessoa";

export class EnumBancaViewModel {
    static async getPapeisFromApi(): Promise<string[]> {
        const response = await api.get('/papelMembro');
        return response.data;
    }
    
    static async getPapeis(): Promise<string[]> {
        const storedPapeis = sessionStorage.getItem('papeis');
        if (storedPapeis) {
            return JSON.parse(storedPapeis);
        }
    
        const papeis = await this.getPapeisFromApi();
        sessionStorage.setItem('papeis', JSON.stringify(papeis));
        return papeis;
    }
    
    static async mapPapelToId(papel: string): Promise<string> {
        const papeis = await this.getPapeis();
        const papelEncontrado = papeis.find((v: string) => v === papel);
        if (!papelEncontrado) {
            throw new Error(`Papel não encontrado: ${papel}`);
        }
        return papelEncontrado;
    }
    
    static async getVinculosFromApi(): Promise<Vinculo[]> {
        const response = await api.get('/vinculos');
        return response.data;
    }
    
    static async getVinculos(): Promise<Vinculo[]> {
        const storedPapeis = sessionStorage.getItem('vinculos');
        if (storedPapeis) {
            return JSON.parse(storedPapeis);
        }
    
        const vinculos = await this.getVinculosFromApi();
        sessionStorage.setItem('vinculos', JSON.stringify(vinculos));
        return vinculos;
    }

    static async getTiposBancaFromApi(): Promise<TipoBanca[]> {
        const response = await api.get('/tipoBanca');
        return response.data;
    }
    
    static async getTiposBanca(): Promise<TipoBanca[]> {
        const storedTiposBanca = sessionStorage.getItem('tipos_banca');
        if (storedTiposBanca) {
            return JSON.parse(storedTiposBanca);
        }
    
        const tiposBanca = await this.getTiposBancaFromApi();
        sessionStorage.setItem('tipos_banca', JSON.stringify(tiposBanca));
        return tiposBanca;
    }

    static async getTipoBancaIdByNome(nome: TipoBanca): Promise<TipoBancaNome | null> {
        const tiposBanca = await this.getTiposBanca();
        const tipoBanca = tiposBanca.find(tb => tb === nome);
        return tipoBanca!.nome ? tipoBanca!.nome : null; 
    }
    
    static async mapTipoBancaToId(nome: string ): Promise<string> {
        const tiposBanca = await this.getTiposBanca();
        const tipoBancaEncontrado = tiposBanca.find((v: TipoBanca) => v.nome === nome);
        if (!tipoBancaEncontrado) {
            throw new Error(`Tipo de Banca não encontrado: ${nome}`);
        }
        return tipoBancaEncontrado.nome ? tipoBancaEncontrado.nome : 'EnumBancaViewModel error: mapTipoBancaToId()';
    }
}

